// This file is extracted from the backend code: https://github.com/admi-de/backend/tree/main/common/src/main/resources/adv
import BUILDING_FUNCTIONS_MAPPING from 'src/common/buildingFunctions.json';

export function resolveBuildingFunctionCode(buildingFunctionCode: string): string {
    const buildingFunctionFriendlyName =
        BUILDING_FUNCTIONS_MAPPING[buildingFunctionCode as keyof typeof BUILDING_FUNCTIONS_MAPPING];

    if (!buildingFunctionFriendlyName) {
        console.error(`No friendly name found for building function code: ${buildingFunctionCode}`);
        return buildingFunctionCode;
    }

    return buildingFunctionFriendlyName;
}
